import { SignaturesConstants } from './signatures.constants'
import { ISignatureOldChipData, ISignaturesState } from './signatures.types'

export const initialSignatureOldChipData: ISignatureOldChipData = {
  witnessPrintedName: '',
  witnessPhone: '',
  witnessAddress: '',
  sectionTwoReasonIncapableOfSigning: '',
  sectionTwoSelectedOptionIncapableOfSigning: null,
  sectionTwoAuthorizedRepresentative: null,
  representativePrintedName: '',
  representativePhone: '',
  representativeAddress: '',
  sectionThreeReasonIncapableOfSigning: '',
  sectionThreeSelectedOptionIncapableOfSigning: null,
  crew: null,
  receivingFacilityPrintedName: '',
  receivingFacilityRepTitle: '',
}

export const initialSignaturesState: ISignaturesState = {
  acknowledgePrivacyNotice: false,
  acknowledgmentText: '',
  signatureSection: null,
  patientSignature: null,
  isMark: null,
  witnessSignature: null,
  ambulanceCrewSignature: null,
  representativeSignature: null,
  receivingFacilitySignature: null,
  crewSignature: null,
  selectedSignatureType: null,
  currentSignature: new Blob(),
  tempSignature: '',
  attachments: [],
  attachmentId: '',
  attachmentType: '',
  fileName: '',
  patientPrintedName: '',
  witnessPrintedName: '',
  witnessPhone: '',
  witnessAddress: '',
  ambulancePrintedName: '',
  representativePrintedName: '',
  representativePhone: '',
  representativeAddress: '',
  receivingFacilityPrintedName: '',
  sectionTwoReasonIncapableOfSigning: '',
  sectionTwoSelectedOptionIncapableOfSigning: null,
  sectionTwoAuthorizedRepresentative: null,
  sectionThreeReasonIncapableOfSigning: '',
  sectionThreeSelectedOptionIncapableOfSigning: null,
  saveSignatureOnSaveClick: false,
  isSectionLockedFlag: false,
  crew: null,
  receivingFacilityRepTitle: '',
  clearSignatureSectionOnClick: false,
  ambulanceSignatureDt: '',
  patientSignatureDt: '',
  witnessSignatureDt: '',
  representativeSignatureDt: '',
  crewSignatureDt: '',
  receivingFacilitySignatureDt: '',
  chips: [],
  currentSelectedChip: null,
  showAttachments: false,
  updatedTerms: '',
  sectionIHeaderText: '',
  sectionIIHeaderText: '',
  sectionIIIHeaderText: '',
  signatureOldChipData: initialSignatureOldChipData,
}

export function signaturesReducer(state: ISignaturesState = initialSignaturesState, action: any): ISignaturesState {
  switch (action.type) {
    case SignaturesConstants.SET_SIGNATURE_SECTION:
      return { ...state, signatureSection: action.signatureSection }
    case SignaturesConstants.SET_PATIENT_SIGNATURE:
      return { ...state, patientSignature: action.patientSignature }
    case SignaturesConstants.SET_IS_MARK:
      return { ...state, isMark: action.isMark }
    case SignaturesConstants.SET_WITNESS_SIGNATURE:
      return { ...state, witnessSignature: action.witnessSignature }
    case SignaturesConstants.SET_AMBULANCE_CREW_SIGNATURE:
      return { ...state, ambulanceCrewSignature: action.ambulanceCrewSignature }
    case SignaturesConstants.SET_REPRESENTATIVE_SIGNATURE:
      return { ...state, representativeSignature: action.representativeSignature }
    case SignaturesConstants.SET_RECIEVING_FACILITY_SIGNATURE:
      return { ...state, receivingFacilitySignature: action.receivingFacilitySignature }
    case SignaturesConstants.SET_CREW_SIGNATURE:
      return { ...state, crewSignature: action.crewSignature }
    case SignaturesConstants.SET_SELECTED_SIGNATURE_TYPE:
      return { ...state, selectedSignatureType: action.selectedSignatureType }
    case SignaturesConstants.SAVE_SIGNATURES:
      return { ...state, currentSignature: action.signature }
    case SignaturesConstants.DELETE_SIGNATURE_TYPE:
      return { ...state, selectedSignatureType: action.signature }
    case SignaturesConstants.SAVE_TEMP_SIGNATURE:
      return { ...state, tempSignature: action.signature }
    case SignaturesConstants.CLEAR_TEMP_SIGNATURE:
      return { ...state, tempSignature: action.signature }
    case SignaturesConstants.RESET_STATE:
      return {
        acknowledgePrivacyNotice: false,
        signatureSection: null,
        patientSignature: null,
        isMark: null,
        witnessSignature: null,
        ambulanceCrewSignature: null,
        representativeSignature: null,
        receivingFacilitySignature: null,
        crewSignature: null,
        selectedSignatureType: null,
        currentSignature: new Blob(),
        tempSignature: '',
        attachments: [],
        attachmentId: '',
        attachmentType: '',
        fileName: '',
        patientPrintedName: '',
        witnessPrintedName: '',
        witnessPhone: '',
        witnessAddress: '',
        ambulancePrintedName: '',
        representativePrintedName: '',
        representativePhone: '',
        representativeAddress: '',
        receivingFacilityPrintedName: '',
        crew: null,
        sectionTwoReasonIncapableOfSigning: '',
        sectionTwoSelectedOptionIncapableOfSigning: null,
        sectionTwoAuthorizedRepresentative: null,
        sectionThreeReasonIncapableOfSigning: '',
        sectionThreeSelectedOptionIncapableOfSigning: null,
        saveSignatureOnSaveClick: false,
        isSectionLockedFlag: false,
        receivingFacilityRepTitle: '',
        clearSignatureSectionOnClick: false,
        ambulanceSignatureDt: '',
        patientSignatureDt: '',
        witnessSignatureDt: '',
        representativeSignatureDt: '',
        crewSignatureDt: '',
        receivingFacilitySignatureDt: '',
        chips: [],
        currentSelectedChip: null,
        showAttachments: false,
        updatedTerms: '',
        acknowledgmentText: '',
        sectionIHeaderText: '',
        sectionIIHeaderText: '',
        sectionIIIHeaderText: '',
        signatureOldChipData: {
          witnessPrintedName: '',
          witnessPhone: '',
          witnessAddress: '',
          sectionTwoReasonIncapableOfSigning: '',
          sectionTwoSelectedOptionIncapableOfSigning: null,
          sectionTwoAuthorizedRepresentative: null,
          representativePrintedName: '',
          representativePhone: '',
          representativeAddress: '',
          sectionThreeReasonIncapableOfSigning: '',
          sectionThreeSelectedOptionIncapableOfSigning: null,
          crew: null,
          receivingFacilityPrintedName: '',
          receivingFacilityRepTitle: '',
        },
      }
    case SignaturesConstants.SET_ATTACHMENTS_LIST:
      return { ...state, attachments: action.attachments }
    case SignaturesConstants.SHOW_CONFIRMATION_ALERT:
      return {
        ...state,
        attachmentId: action.attachmentId,
        attachmentType: action.attachmentType,
      }
    case SignaturesConstants.CLEAR_ATTACHMENTS:
      return { ...state, attachments: [] }
    case SignaturesConstants.SET_FILE_NAME:
      return { ...state, fileName: action.fileName }
    case SignaturesConstants.SET_PATIENT_PRINTED_NAME:
      return { ...state, patientPrintedName: action.patientPrintedName }
    case SignaturesConstants.SET_WITNESS_PRINTED_NAME:
      return { ...state, witnessPrintedName: action.witnessPrintedName }
    case SignaturesConstants.SET_WITNESS_PHONE:
      return { ...state, witnessPhone: action.witnessPhone }
    case SignaturesConstants.SET_WITNESS_ADDRESS:
      return { ...state, witnessAddress: action.witnessAddress }
    case SignaturesConstants.SET_AMBULANCE_PRINTED_NAME:
      return { ...state, ambulancePrintedName: action.ambulancePrintedName }
    case SignaturesConstants.SET_REPRESENTATIVE_PRINTED_NAME:
      return { ...state, representativePrintedName: action.representativePrintedName }
    case SignaturesConstants.SET_REPRESENTATIVE_PHONE:
      return { ...state, representativePhone: action.representativePhone }
    case SignaturesConstants.SET_REPRESENTATIVE_ADDRESS:
      return { ...state, representativeAddress: action.representativeAddress }
    case SignaturesConstants.SET_RECEIVING_FACILITY_PRINTED_NAME:
      return { ...state, receivingFacilityPrintedName: action.receivingFacilityPrintedName }
    case SignaturesConstants.SET_RECEIVING_FACILITY_TITLE:
      return { ...state, receivingFacilityRepTitle: action.receivingFacilityRepTitle }
    case SignaturesConstants.SET_CREW:
      return { ...state, crew: action.crew }
    case SignaturesConstants.SET_SECTION_TWO_REASON_INCAPABLE_OF_SIGNING:
      return { ...state, sectionTwoReasonIncapableOfSigning: action.sectionTwoReasonIncapableOfSigning }
    case SignaturesConstants.SET_SECTION_TWO_SELECTED_OPTION_INCAPABLE_OF_SIGNING:
      return { ...state, sectionTwoSelectedOptionIncapableOfSigning: action.sectionTwoSelectedOptionIncapableOfSigning }
    case SignaturesConstants.SET_SECTION_TWO_AUTHORIZED_REPRESENTATIVE:
      return {
        ...state,
        sectionTwoAuthorizedRepresentative: action.sectionTwoAuthorizedRepresentative,
      }
    case SignaturesConstants.SET_SECTION_THREE_REASON_INCAPABLE_OF_SIGNING:
      return { ...state, sectionThreeReasonIncapableOfSigning: action.sectionThreeReasonIncapableOfSigning }
    case SignaturesConstants.SET_SECTION_THREE_SELECTED_OPTION_INCAPABLE_OF_SIGNING:
      return {
        ...state,
        sectionThreeSelectedOptionIncapableOfSigning: action.sectionThreeSelectedOptionIncapableOfSigning,
      }
    case SignaturesConstants.SET_SIGNATURES:
      return { ...state, ...action.signatures }
    case SignaturesConstants.SAVE_SIGNATURE_ON_CLICK:
      return { ...state, saveSignatureOnSaveClick: action.saveSignatureOnSaveClick }
    case SignaturesConstants.SET_IS_SECTION_LOCKED_FLAG:
      return { ...state, isSectionLockedFlag: action.isSectionLockedFlag }
    case SignaturesConstants.SET_UPDATED_TERMS:
      return { ...state, updatedTerms: action.updatedTerms }
    case SignaturesConstants.SET_UPDATED_ACKNOWLEDGEMENT:
      return { ...state, acknowledgmentText: action.acknowledgmentText }
    case SignaturesConstants.CLEAR_SIGNATURE_STATE:
      return {
        ...state,
        acknowledgePrivacyNotice: false,
        patientSignature: null,
        witnessSignature: null,
        ambulanceCrewSignature: null,
        representativeSignature: null,
        receivingFacilitySignature: null,
        crewSignature: null,
        attachments: [],
        attachmentId: '',
        attachmentType: '',
        fileName: '',
        patientPrintedName: '',
        witnessPrintedName: '',
        witnessPhone: '',
        witnessAddress: '',
        ambulancePrintedName: '',
        representativePrintedName: '',
        receivingFacilityPrintedName: '',
        receivingFacilityRepTitle: '',
        crew: null,
        sectionTwoReasonIncapableOfSigning: '',
        sectionTwoSelectedOptionIncapableOfSigning: null,
        sectionTwoAuthorizedRepresentative: null,
        sectionThreeReasonIncapableOfSigning: '',
        sectionThreeSelectedOptionIncapableOfSigning: null,
        isSectionLockedFlag: false,
        ambulanceSignatureDt: '',
        patientSignatureDt: '',
        witnessSignatureDt: '',
        representativeSignatureDt: '',
        crewSignatureDt: '',
        receivingFacilitySignatureDt: '',
        chips: [],
        currentSelectedChip: null,
        currentSignature: new Blob(),
        selectedSignatureType: null,
        signatureSection: null,
        showAttachments: false,
        updatedTerms: '',
        sectionIHeaderText: '',
        sectionIIHeaderText: '',
        sectionIIIHeaderText: '',
        representativePhone: '',
        representativeAddress: '',
        isMark: null,
        signatureOldChipData: {
          witnessPrintedName: '',
          witnessPhone: '',
          witnessAddress: '',
          sectionTwoReasonIncapableOfSigning: '',
          sectionTwoSelectedOptionIncapableOfSigning: null,
          sectionTwoAuthorizedRepresentative: null,
          representativePrintedName: '',
          representativePhone: '',
          representativeAddress: '',
          sectionThreeReasonIncapableOfSigning: '',
          sectionThreeSelectedOptionIncapableOfSigning: null,
          crew: null,
          receivingFacilityPrintedName: '',
          receivingFacilityRepTitle: '',
        },
      }
    case SignaturesConstants.CLEAR_SIGNATURE_TEMP_STATE:
      return {
        ...state,
        currentSelectedChip: null,
        patientSignature: null,
        witnessSignature: null,
        ambulanceCrewSignature: null,
        representativeSignature: null,
        receivingFacilitySignature: null,
        crewSignature: null,
        patientPrintedName: '',
        witnessPrintedName: '',
        ambulancePrintedName: '',
        representativePrintedName: '',
        receivingFacilityPrintedName: '',
        receivingFacilityRepTitle: '',
        crew: null,
        sectionTwoReasonIncapableOfSigning: '',
        sectionTwoSelectedOptionIncapableOfSigning: null,
        sectionTwoAuthorizedRepresentative: null,
        sectionThreeReasonIncapableOfSigning: '',
        sectionThreeSelectedOptionIncapableOfSigning: null,
        ambulanceSignatureDt: '',
        patientSignatureDt: '',
        witnessSignatureDt: '',
        representativeSignatureDt: '',
        crewSignatureDt: '',
        receivingFacilitySignatureDt: '',
        currentSignature: new Blob(),
        selectedSignatureType: null,
        signatureSection: null,
        tempSignature: '',
      }
    case SignaturesConstants.SET_AMBULANCE_SIGNATURE_DT:
      return {
        ...state,
        ambulanceSignatureDt: action.ambulanceSignatureDt,
      }
    case SignaturesConstants.SET_REPRESENTATIVE_SIGNATURE_DT:
      return {
        ...state,
        representativeSignatureDt: action.representativeSignatureDt,
      }
    case SignaturesConstants.SET_PATIENT_SIGNATURE_DT:
      return {
        ...state,
        patientSignatureDt: action.patientSignatureDt,
      }
    case SignaturesConstants.SET_WITNESS_SIGNATURE_DT:
      return {
        ...state,
        witnessSignatureDt: action.witnessSignatureDt,
      }
    case SignaturesConstants.SET_CREW_SIGNATURE_DT:
      return {
        ...state,
        crewSignatureDt: action.crewSignatureDt,
      }
    case SignaturesConstants.SET_RECEIVING_FACILITY_SIGNATURE_DT:
      return {
        ...state,
        receivingFacilitySignatureDt: action.receivingFacilitySignatureDt,
      }
    case SignaturesConstants.CLEAR_SIGNATURE_SECTION_ON_CLICK:
      return {
        ...state,
        clearSignatureSectionOnClick: action.clearSignatureSectionOnClick,
      }
    case SignaturesConstants.SET_SELECTED_CHECKBOX:
      return {
        ...state,
        acknowledgePrivacyNotice: action.acknowledgePrivacyNotice,
      }
    case SignaturesConstants.SET_SIGNATURE_CHIP:
      return {
        ...state,
        chips: action.chips,
      }
    case SignaturesConstants.LOAD_SIGNATURE_DATA:
      return {
        ...state,
        currentSelectedChip: action.currentSelectedChip,
      }
    case SignaturesConstants.SHOW_ATTACHMENTS:
      return {
        ...state,
        showAttachments: action.showAttachments,
      }
    case SignaturesConstants.SET_SECTION_I_HEADERTEXT:
      return {
        ...state,
        sectionIHeaderText: action.headertext,
      }
    case SignaturesConstants.SET_SECTION_II_HEADERTEXT:
      return {
        ...state,
        sectionIIHeaderText: action.headertext,
      }
    case SignaturesConstants.SET_SECTION_III_HEADERTEXT:
      return {
        ...state,
        sectionIIIHeaderText: action.headertext,
      }
    case SignaturesConstants.SAVE_SIGNATURE_CHIPS_DATA:
      return {
        ...state,
        signatureOldChipData: {
          witnessPrintedName: state.witnessPrintedName,
          witnessPhone: state.witnessPhone,
          witnessAddress: state.witnessAddress,
          sectionTwoReasonIncapableOfSigning: state.sectionTwoReasonIncapableOfSigning,
          sectionTwoSelectedOptionIncapableOfSigning: state.sectionTwoSelectedOptionIncapableOfSigning,
          sectionTwoAuthorizedRepresentative: state.sectionTwoAuthorizedRepresentative,
          representativePrintedName: state.representativePrintedName,
          representativePhone: state.representativePhone,
          representativeAddress: state.representativeAddress,
          sectionThreeReasonIncapableOfSigning: state.sectionThreeReasonIncapableOfSigning,
          sectionThreeSelectedOptionIncapableOfSigning: state.sectionThreeSelectedOptionIncapableOfSigning,
          crew: state.crew,
          receivingFacilityPrintedName: state.receivingFacilityPrintedName,
          receivingFacilityRepTitle: state.receivingFacilityRepTitle,
        },
      }
    default:
      return state
  }
}
